import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";

export class AccountsValidationTableCtrl implements IController {
  accounts: AccountModel[];
  selectedIds: any;
  isEditable: any;
  queryString: any;
  onSelectedIdsChanged: Function;
  onRemove: Function;
  onEdit: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }


  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggleAccount(accountId) {
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if(value) return key;
    });
    this.onSelectedIdsChanged({selectedIds : _.compact(selectedIds)});
  }

  onToggleAllAccounts() {
    var selectedIds = !_.isEqual(this.selectedIds.length, this.accounts.length) ?
      _.map(this.accounts, (account: AccountModel) => {
        return account.accountId;
      }) : [];

    this.onSelectedIdsChanged({selectedIds : selectedIds});
  }

  onRemoveAccount(id) {
    this.onRemove({ids: [id]});
  }

  onEditAccount(account: AccountModel) {
    this.onEdit({account: account})
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountsValidationTable', {
    bindings: {
      accounts: '<',
      selectedIds: '<',
      isEditable: '<',
      queryString: '<',
      onSelectedIdsChanged: '&',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./accounts-validation-table.html').default,
    controller: AccountsValidationTableCtrl
  });
